import { motion } from "framer-motion";

const ITEMS = [
  {
    n: "01",
    title: "Sonic Branding & Design",
    detail:
      "We develop distinctive sonic identities that give brands a recognisable and emotionally consistent presence across every touchpoint. From audio logos to full sonic identity systems, we create the acoustic foundations of modern brands — thoughtfully composed, strategically aligned and designed to scale.",
  },
  {
    n: "02",
    title: "Campaign Development",
    detail:
      "We develop creative audio-led concepts for campaigns that want to move beyond the expected — where sound is not an afterthought, but a core creative force, shaping mood, memory and meaning from the very beginning.",
  },
  {
    n: "03",
    title: "Podcast Production",
    detail:
      "We create and elevate podcast formats with a strong sense of identity, atmosphere and quality. From format development to sonic identity and production, we help brands create podcasts that sound considered, confident and genuinely worth listening to.",
  },
  {
    n: "04",
    title: "Music Strategy & Consulting",
    detail:
      "We help brands make better decisions around music — creatively, strategically and culturally. Music should never be random. We define a clear musical direction that strengthens identity, sharpens perception and creates consistency across content, campaigns and experiences.",
  },
];

export default function Disciplines() {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="px-6 lg:px-14 py-24 lg:py-36"
    >
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-16 gap-6">
        <p className="font-mono-accent text-[11px] uppercase tracking-[0.4em] text-[#8C857B]">
          04 / Expertise
        </p>
        <h2 className="font-serif-display font-light text-4xl sm:text-5xl tracking-tight leading-[1.05] text-[#121110] max-w-xl">
          Sound as a <span className="italic text-[#8C857B]">core creative force.</span>
        </h2>
      </div>

      <div className="flex flex-col border-t border-[#121110]/12">
        {ITEMS.map((it, i) => (
          <motion.article
            key={it.n}
            data-testid={`expertise-item-${i + 1}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="group grid md:grid-cols-[auto_1fr] gap-6 md:gap-12 py-10 lg:py-14 border-b border-[#121110]/12"
          >
            <div className="flex items-start gap-6">
              <span className="font-serif-display text-3xl text-[#C5A880] leading-none">{it.n}</span>
            </div>
            <div className="md:grid md:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] md:gap-14 items-start">
              <h3 className="font-serif-display font-light text-3xl lg:text-4xl leading-tight text-[#121110] mb-4 md:mb-0 transition-transform duration-500 ease-out md:group-hover:translate-x-2">
                {it.title}
              </h3>
              <p className="text-[#5C5650] text-sm sm:text-base leading-relaxed font-light max-w-2xl">
                {it.detail}
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
